
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { isAuthenticatedAction } from "../modules/auth/actions";
import { authTypeSelector, isAuthenticatedSelector } from "../modules/auth/selectors";
import { Redirect } from "../components/tools/Redirect";
import { ROOT } from "../global/urlMapping";
import { postLoginSelector } from "../modules/postLogin/selectors";
import { CFTNS } from "../modules/auth/actionsType";


export const AuthComp = ({ children, fallback }) => {
    const dispatch = useDispatch()
    const isAuthenticated = useSelector(isAuthenticatedSelector);
    const authType = useSelector(authTypeSelector)
    const postLogin = useSelector(postLoginSelector)

    const isAuthenticatedFunction = () => {
        if (isAuthenticated && authType === CFTNS && !sessionStorage.CFTNS)
            return false;
        else
            return isAuthenticated
    }
    useEffect(() => {
        dispatch(isAuthenticatedAction())

    }, [dispatch, isAuthenticated])

    return (

        !isAuthenticatedFunction() ? fallback :
            !postLogin?.value ? < Redirect link={ROOT} /> :
                isAuthenticatedFunction() && postLogin?.value ? children :
                    <></>
    );
};